export default "__VITE_PUBLIC_ASSET__6aee5182__"